import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateVisit } from '../api/visits';

export function useUpdateVisit() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateVisit,
    onSuccess: (updatedVisit) => {
      // Invalidate and refetch visits queries
      queryClient.invalidateQueries({ queryKey: ['visits'] });
      queryClient.invalidateQueries({ queryKey: ['visit-history'] });
      
      // Update the visit in the cache
      queryClient.setQueryData(
        ['visit', updatedVisit.id],
        updatedVisit
      );
    },
  });
}